import React from 'react';
import {useLocation} from 'react-router';

import {legacyDocsUrl, stripDocsBasePath} from '../../site-config.mjs';

export default function LegacyDocsBanner(): React.ReactNode {
  const location = useLocation();
  const path = stripDocsBasePath(location.pathname) || '/';
  const isChinese = path === '/zh-CN' || path.startsWith('/zh-CN/');

  return (
    <div className="legacy-docs-banner" style={{color: '#111111'}}>
      <span>
        {isChinese
          ? '欢迎使用全新的 WEEX API 文档。需要查看旧版本？'
          : 'Welcome to the new WEEX API documentation. Looking for the previous version?'}
      </span>
      {isChinese ? (
        <span>
          切换到
          <a
            href={legacyDocsUrl}
            style={{
              color: '#111111',
              textDecorationColor: '#111111',
              textDecorationLine: 'underline',
              textDecorationThickness: '1px',
              textUnderlineOffset: '3px',
            }}
          >
            旧版文档
          </a>
        </span>
      ) : (
        <span>
          Switch to the
          {' '}
          <a
            href={legacyDocsUrl}
            style={{
              color: '#111111',
              textDecorationColor: '#111111',
              textDecorationLine: 'underline',
              textDecorationThickness: '1px',
              textUnderlineOffset: '3px',
            }}
          >
            legacy docs
          </a>
        </span>
      )}
    </div>
  );
}
